import { FetchResult, gql } from 'apollo-boost';
import { IUser } from '../../models/user';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const MUTATION = gql`
    mutation UserConfigRemoveNarrative($narrativeUid: String!){
        user_config_remove_narrative (narrativeUid: $narrativeUid) {
            success,
            user {
                uid,
                narratives {
                    uid
                },
            },
        }
    }
`;

export interface IResultRemoveNarrative {
    success: boolean;
    user: IUser;
}

export async function removeNarrativeFromUser(narrativeUid: string): Promise<IUser> {
    const result: FetchResult<{ user_config_remove_narrative: IResultRemoveNarrative }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { narrativeUid },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_config_remove_narrative.user;
}
